import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { injectMetaTags } from "@/lib/seoHelpers";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Page Not Found | Windows and Doors Repair LLC";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "The page you are looking for does not exist. Browse our window repair services across Miami-Dade.");

    const cleanupSeo = injectMetaTags({
      title: "Page Not Found | Windows and Doors Repair LLC",
      description: "The page you are looking for does not exist. Browse our window repair services across Miami-Dade.",
      url: `https://impact-window-repair-miami.com${location.pathname}`,
      image: "https://impact-window-repair-miami.com/og/og-default.jpg",
      imageAlt: "Page not found Windows and Doors Repair LLC",
      type: "website",
    });

    return () => {
      cleanupSeo();
    };
  }, [location.pathname]);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-stone-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">This page has not been generated</h1>
        <p className="mt-2 text-base text-stone-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-stone-500">Tell me more about this page, so I can generate it</p>
      </div>
    </div>
  );
}